<div class="payment-container">
  <div class="header-section">
    <svg class="success-icon" lucideCheckCircle></svg>
    <h1 class="text-h1">¡Pago Exitoso!</h1>
    <p>Muchas gracias por tu visita. Esperamos verte pronto.</p>
  </div>

  @if (billData(); as bill) {
    <div class="receipt-card">
      <div class="receipt-header">
        <h2>Detalle de tu Consumo</h2>
        <span class="table-info">Mesa {{ selectedTable() }}</span>
      </div>

      <div class="receipt-divider"></div>

      <div class="receipt-items">
        @for (item of billData().details; track item.orderProductId) {
          <div class="item-row">
            <div class="item-info">
              <span class="qty">{{ item.quantity }}x</span>
              <span class="name">{{ item.product }}</span>
            </div>
            <span class="price">{{ item.price | clpFormat }}</span>
          </div>
        } @empty {
          <p class="empty-text">No hay detalles disponibles.</p>
        }
      </div>

      <div class="receipt-divider"></div>

      @if (bill.totals) {
        <div class="receipt-totals">
          <div class="total-row">
            <span>Subtotal</span>
            <span>{{ bill.totals.totalAmount | clpFormat }}</span>
          </div>

          @if (bill.totals.propinaSugerida > 0) {
            <div class="total-row tip">
              <span>Propina (10%)</span>
              <span>{{ bill.totals.propinaSugerida | clpFormat }}</span>
            </div>
          }

          <div class="total-row final">
            <span>Total Pagado</span>
            <span>{{ bill.totals.totalConPropina | clpFormat }}</span>
          </div>
        </div>
      }
    </div>
  }

  <button (click)="goToMenu()" class="btn-main primary" color="primary" mat-raised-button>
    Continuar
  </button>
</div>
